module.exports = __webpack_public_path__ + "img/con1-img.3afc5125.png";